import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, FormControl, InputLabel, Select, MenuItem, Checkbox } from "@material-ui/core";
import WarningIcon from '@material-ui/icons/Warning';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SpeedIcon from '@material-ui/icons/Speed';
import t from "../../../../../languages/pl";
import guid from './../../../../../utils/guid';

const useStyles = theme => ({
    formControl: {
        minWidth: 200,
        margin: theme.spacing(1),
        alignSelf: "flex-start"
    },
    select: {
        display: "flex",
        alignItems: "center",
    },
    icon: {
        width: 18,
        height: 18,
        paddingRight: theme.spacing(0.5),
    },
    multiselect: {
        width: 300,
        maxWidth: 300
    }
});

const options = iconClass => [
    {
        name: t.criticalIncidents,
        icon: <WarningIcon style={{color: 'red'}} className={iconClass} />
    },
    {
        name: t.incidents,
        icon: <WarningIcon className={iconClass} />
    },
    {
        name: t.gps,
        icon: <GpsFixedIcon className={iconClass} />
    },
    {
        name: t.driversLogs,
        icon: <VpnKeyIcon className={iconClass} />
    },
    {
        name: t.measurements,
        icon: <AssessmentIcon className={iconClass} />
    },
    {
        name: t.overLimits,
        icon: <SpeedIcon className={iconClass} />
    }
];

const SelectDataFilter = ({classes, value, onChange}) => {
    const selectOptions = options(classes.icon);
    const printOptions = () => selectOptions.map(option => (
        <MenuItem
            key={guid()}
            value={option.name}
        >
            <Checkbox checked={value.indexOf(option.name) > -1} />
            {option.icon} {option.name}
        </MenuItem>
    ));

    return (
        <React.Fragment>
            <FormControl className={classes.formControl}>
                <InputLabel>Filtruj</InputLabel>
            <Select
                classes={{select: classes.select}}
                className={classes.multiselect}
                defaultValue=""
                multiple
                value={value}
                onChange={e => onChange && onChange(e.target.value)}
                renderValue={(selected) => selected.join(', ')}
            >
                <MenuItem value=""><em>{t.all}</em></MenuItem>
                {printOptions()}
            </Select>
            </FormControl>
        </React.Fragment>
    );
};

SelectDataFilter.propTypes = {
    classes: PropTypes.object,
    value: PropTypes.array,
    onChange: PropTypes.func
};

export default withStyles(useStyles)(SelectDataFilter);
